import registerDebug from 'debug';
/**
 * The parent namespace should be 'mfs', this allows us to to turn on off all trace logs from all mfs packages.
 * Namespaces can be enabled in client apps by using trace.enable(mfs:*) or in the local storage of the browser
 */
const parent = registerDebug('mfs');
/**
 * Utility method to log anything but exceptions to console. Uses 'trace' npm library internally.
 *
 * @param level Level of logging ( like error, info, etc)
 * @param message Console message to be displayed
 * @param component Component of MfsSdk from which the log originated
 * @param logParams Parameters to be displayed only as console arguments. They will be appended to the message
 */
export function logGenericToConsole(level, message, component, logParams) {
    const logger = parent.extend(component);
    switch (level) {
        case "error" /* ERROR */:
            logger.log = console.error.bind(console);
            break;
        case "trace" /* TRACE */:
            logger.log = console.log.bind(console);
            break;
        case "warn" /* WARN */:
            logger.log = console.warn.bind(console);
            break;
        default:
            logger.log = console.info.bind(console);
            break;
    }
    if (!logParams) {
        logger(message);
    }
    else {
        logger(message, logParams);
    }
}
/**
 * Utility method to log exceptions to console. Uses 'debug' npm library internally.They will be appended to the message
 *
 * @param level Level of logging ( like error, info, etc)
 * @param component Component of MfsSdk from which the log originated
 * @param error Error info or warning info
 * @param logParams Parameters to be displayed only as console arguments
 */
export function logErrorToConsole(level, component, error, logParams) {
    if (!error) {
        return;
    }
    const logger = parent.extend(component);
    switch (level) {
        case "warn" /* WARN */:
            logger.log = console.warn.bind(console);
            break;
        case "error" /* ERROR */:
            logger.log = console.error.bind(console);
            break;
    }
    if (!logParams) {
        logger(error.message, error.error);
    }
    else {
        logger(error.message, error.error, logParams);
    }
}
//# sourceMappingURL=logToConsole.js.map